var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOff = function SvgOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 22c6.018 0 11-4.993 11-11 0-6.018-4.993-11-11.01-11C4.981 0 0 4.982 0 11c0 6.007 4.993 11 11 11m-4.055-8.045v-5.91c0-.69.42-1.09 1.11-1.09h5.868c.7 0 1.11.4 1.11 1.09v5.91c0 .68-.41 1.09-1.11 1.09H8.055c-.69 0-1.11-.41-1.11-1.09"
  })));
};
export default SvgOff;